module.exports = __webpack_public_path__ + "static/media/barrel.7f7ad56a.mp3";